import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Key = (props: Icon): React.ReactElement => {
  if (props.variant === "line") {
    return (
      <svg
        viewBox="0 0 24 24"
        style={{ ...style(props.size, props.height), ...props.style }}
        className={props.className}
      >
        <path
          d="M15.5 1A7.499 7.499 0 0 0 8 8.5c0 .468.05.925.131 1.369L1.001
          17v6h6v-4h4v-3h4.5A7.5 7.5 0 0 0 23 8.5C23 4.357 19.642 1 15.5 1z"
          stroke={props.color || theme.palette.grey600}
          strokeWidth={2}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        d="M16.001.001a8 8 0 0 0-8 8c0
        .617.076 1.215.208 1.792L.001
        18.001v6h6v-3h3v-3h3l2.209-2.208a8.015 8.015 0 0 0
        1.791.208 8 8 0 0 0 0-16zm1.5 8A1.5 1.5 0 1 1 17.502 5 1.5 1.5 0 0
        1 17.501 8z"
        fill={props.color || theme.palette.grey600}
        fillRule="nonzero"
      />
    </svg>
  );
};
